import React, { useEffect } from "react";
import iconLogo from "../../../assets/media/icon-logo.png";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../../navbar";
import Header from "../../header";
import { useDispatch, useSelector } from "react-redux";
import {
  setApplyingForm,
} from "../../../store/reducers/counterSlice";
import { fetchForms } from "../../../store/reducers/formSlice";
import { fetchCategories } from "../../../store/reducers/categoriesSlice";

const AppFormsAdmin = () => {
  const accessToken = useSelector((state) => state.auth.user.access_token);
  const categories = useSelector((state) => state.categories);
  const forms = useSelector((state) => state.forms);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const location = useLocation(); // ✅ first
  const queryParams = new URLSearchParams(location.search);
  const urlCategoryId = queryParams.get("item");

  // Get the active category ID - use URL param if available, otherwise use first category
  const getActiveCategoryId = () => {
    if (urlCategoryId) {
      return Number(urlCategoryId);
    }
    // If no URL param and categories are loaded, use first category
    if (categories?.data?.length > 0) {
      return categories.data[0].id;
    }
    // Fallback while loading
    return null;
  };

  const activeCategoryId = getActiveCategoryId();
  const activeCategoryName = categories?.data?.find(
    (c) => c.id === activeCategoryId
  )?.name;

  // Fallback: if we have an activeCategoryId but no name, try to get it from the first category
  const fallbackCategoryName = activeCategoryId && !activeCategoryName && categories?.data?.length > 0
    ? categories.data[0].name
    : activeCategoryName;

  // Debug logging for URL binding
  console.log('URL Debug Info:');
  console.log('- Current URL:', location.search);
  console.log('- Active Category ID from URL:', activeCategoryId);
  console.log('- Active Category Name:', activeCategoryName);
  console.log('- Fallback Category Name:', fallbackCategoryName);
  console.log('- Categories available:', categories?.data?.map(c => ({ id: c.id, name: c.name })));
  console.log('- Categories state:', categories);
  console.log('- Access token:', accessToken ? 'Present' : 'Missing');

  useEffect(() => {
    console.log('useEffect triggered - accessToken:', accessToken ? 'Present' : 'Missing');
    if (accessToken) {
      console.log('Dispatching fetchForms and fetchCategories...');
      dispatch(fetchForms({ accessToken: accessToken }));
      dispatch(fetchCategories({ accessToken: accessToken }));
    } else {
      console.log('No access token, skipping fetch');
    }
  }, [accessToken, dispatch]);

  // Debug categories state changes
  useEffect(() => {
    console.log('Categories state changed:', {
      loading: categories?.fetchLoading,
      error: categories?.fetchError,
      dataLength: categories?.data?.length,
      data: categories?.data
    });

    // If there's an error fetching categories, log it
    if (categories?.fetchError) {
      console.error('Error fetching categories:', categories.fetchError);
    }
  }, [categories]);

  // Auto-navigate to first tab if no item parameter is present
  useEffect(() => {
    if (categories?.data?.length > 0 && !urlCategoryId) {
      const firstCategoryId = categories.data[0].id;
      console.log('Auto-navigating to first category:', firstCategoryId);
      navigate(`/forms?item=${firstCategoryId}`, { replace: true });
    }
  }, [categories?.data, urlCategoryId, navigate]);

  // Ensure first tab is active on initial load
  useEffect(() => {
    if (categories?.data?.length > 0 && !urlCategoryId && activeCategoryId === null) {
      const firstCategoryId = categories.data[0].id;
      console.log('Ensuring first category is active:', firstCategoryId);
      navigate(`/forms?item=${firstCategoryId}`, { replace: true });
    }
  }, [categories?.data, urlCategoryId, activeCategoryId, navigate]);

  const handleGotoApplyNow = (data) => {
    console.log({ data });
    dispatch(
      setApplyingForm({
        form: data?.json_data,
        id: data?.id,
        name: data?.name,
        category: data?.category,
      })
    );
    navigate(`/app-form/${data?.id}`, {
      state: {
        category: "Gaming License & Tax",
      },
    });
  };
  return (
    <div>
      <Navbar />
      <Header />
      <div className="wrapper">
        <div className="profHeader">
          <div className="profHeadLeft">
            <h2>Application Forms</h2>
          </div>
          {/* <div className='profHeadRight'>
                        <Link className='buttonPrimary' to={'/form-step-01'}>Upload PDF Form</Link>
                    </div> */}
        </div>
        <div className="boxAppForms boxWhite">
          <ul>
            {categories?.data?.map((item, index) => (
              <li key={index}>
                <a
                  className={`${activeCategoryId === item.id ? "active" : ""
                    }`}
                  onClick={() => {
                    console.log('Clicked category:', item.name, 'ID:', item.id);
                    navigate(`/forms?item=${item.id}`, {
                      state: {
                        category: item.name,
                      },
                    });
                  }}
                >
                  {item.name}
                  <span>{item.formCount}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="divAppForms">
          <div className="rowAppForms">
            {!forms?.fetchLoading ? (
              forms?.data?.filter(form => form.category === (fallbackCategoryName || activeCategoryName) && form.is_published).length > 0 ? (
                forms.data
                  .filter(form => form.category === (fallbackCategoryName || activeCategoryName) && form.is_published)
                  .map((form, i) => (
                    <div className="colAppForm" key={i}>
                      <div className="AppFormWrap">
                        <img src={iconLogo} alt="" />
                        <h3>{form.name}</h3>
                        <p>{form.category}</p>
                        <div className="buttonGroup">
                          <a
                            className="AppFormButton"
                            onClick={() => handleGotoApplyNow(form)}
                          >
                            Apply Now
                          </a>
                        </div>
                      </div>
                    </div>
                  ))
              ) : (
                <div className="no-forms-message">
                  <p>No forms available for this category.</p>
                </div>
              )
            ) : (
              <div className="loading-message text-center w-100 mt-5">
                <div className="application-spinner">
                  <div className="spinner "></div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default AppFormsAdmin;
